import { Stack, Text } from '@chakra-ui/react';

import LearnerBadgesList from '@/client/components/learners/badges/LearnerBadgesList';
import LearnerDashboardNoDataPlaceholder from '@/client/components/learners/dashboard/components/LearnerDashboardNoDataPlaceholder';
import { useAuthStore } from '@/client/services/state/authStore';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function LearnerDashboardBadges() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { authConfig } = useAuthStore();
  const { user } = authConfig;
  const { _id: userId } = user;

  return (
    <Stack spacing={4}>
      <Text fontSize="18px" fontWeight={600}>
        {t('learners.dashboard.achievements.badges')}
      </Text>

      <LearnerBadgesList
        userId={userId}
        modalNoDataCopy={t('learners.dashboard.achievements.badges.noneFound')}
        noDataPlaceholder={
          <LearnerDashboardNoDataPlaceholder
            imagePath="/public/images/Knowledge-Base-2--Streamline-Brooklyn.svg"
            title={t('learners.dashboard.achievements.badges.noneFound')}
            helpText=""
            buttonData={{
              buttonCopy: t('learners.dashboard.achievements.badges.noneFound.buttonCopy'),
              buttonAction: () => {
                navigate('/explore');
              },
            }}
          />
        }
      />
    </Stack>
  );
}
